import {useQuery} from 'react-query';
import {userChats} from 'services/farm/chatList';

const useGetChatted = (params: UseGetChattedProps) => {
  const {data, isLoading, refetch} = useQuery(
    ['user-farm-chats', params.app],
    userChats,
  );
  return {userChatData: data, userChatDataIsloading: isLoading, refetch};
};
export default useGetChatted;
